import React from 'react';
import styled from 'styled-components';

const GalleryOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: auto;
  height: 60%;
`;

const Gallery = ({ isGalleryVisible, galleryImagePath, closeGallery }) => {
  if (!isGalleryVisible) return null;

  return (
    <GalleryOverlay onClick={closeGallery}>
      <Image src={galleryImagePath} />
    </GalleryOverlay>
  );
};

export default Gallery;
